import React from 'react'
import './Header.css'
import SearchIcon from '@mui/icons-material/Search';
import HeaderComponents from './HeaderComponents';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import HomeIcon from '@mui/icons-material/Home';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import ChatIcon from '@mui/icons-material/Chat';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useDispatch } from 'react-redux';
import { logout } from './features/userSlice';
import { auth } from './firebase';

function Header() {
  const dispatch = useDispatch();

  const logoutOfApp = () => {
    dispatch(logout());
    auth.signOut();
  };

  return (
    <div className='header'>
      <div className='header_left'>

        <div className='linkedin_icon'></div>

        <div className='header_search'>
          <SearchIcon />
          <input placeholder='Search' type='text'></input>

        </div>

      </div>

      <div className='header_right'>
        <HeaderComponents Icon={HomeIcon} title='Home'/>
        <HeaderComponents Icon={SupervisorAccountIcon} title='My Network'/>
        <HeaderComponents Icon={BusinessCenterIcon} title='Jobs'/>
        <HeaderComponents Icon={ChatIcon} title='Messaging'/>
        <HeaderComponents Icon={NotificationsIcon} title='Notifications'/>
        <HeaderComponents onClick={logoutOfApp}
        avatar={true} title='me'/>
      </div>

    </div>
  )
}

export default Header